import { SelectLang } from '@umijs/max';
import type { DropDownProps } from 'antd/es/dropdown';
import React from 'react';

export type HeaderSelectLangProps = Omit<DropDownProps, 'overlay'>;

const HeaderSelectLang: React.FC<HeaderSelectLangProps> = (props) => (
  <SelectLang {...props} />
);

export default HeaderSelectLang;
